import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import { MSAA_QUALITY } from '@pixi/constants';
var GLFramebuffer = /*#__PURE__*/_createClass(function GLFramebuffer(framebuffer) {
  _classCallCheck(this, GLFramebuffer);
  this.framebuffer = framebuffer;
  this.stencil = null;
  this.dirtyId = -1;
  this.dirtyFormat = -1;
  this.dirtySize = -1;
  this.multisample = MSAA_QUALITY.NONE;
  this.msaaBuffer = null;
  this.blitFramebuffer = null;
  this.mipLevel = 0;
});
export { GLFramebuffer };